<template>
  <div class="card shadow rounded border-0 d-none d-sm-flex flex-column h-100" style="max-height: 50em">
    <div class="card-body overflow-auto" style="flex: 1 1 auto;">
      <p class="h5">Exames adicionados</p>
      <div class="row">
        <div class="col-md-7">
          <p>Você adicionou: {{exams?.length}} exame{{exams?.length > 1 ? 's' : ''}}</p>
        </div>
        <div class="col-md-5 text-end">
          <a class="text-danger" href="#" @click.prevent="removeAll()">Remover todos</a>
        </div>
      </div>

      <div class="row">
        <div class="card mb-1" v-for="exam in exams" :key="exam.id_item">
          <div class="card-body py-2">
            <h5 class="card-title">{{ exam.exam_tuss_code }}</h5>
            <p class="card-text">
              {{ exam.exam_name }}
            </p>
            <a class="text-danger" href="#" @click.prevent="removeItem(exam)">Remover exame</a>
          </div>
        </div>
      </div>
    </div>

    <div class="card-footer" v-if="showFooter">
      <button type="button" @click="addToCart" class="btn btn-primary text-muted w-100">
        Buscar laboratório
      </button>
    </div>
  </div>

</template>

<script>
export default {
  name: "ExamCart",
  props: ['exams', 'showFooter'],
  methods: {
    removeAll() {
      this.$emit('removeAll')
    },
    removeItem(item) {
      this.$emit('removeItem', item)
    },
    addToCart() {
      this.$emit('addToCart')
    }
  }
}
</script>

<style scoped>

</style>